// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_URL } from "constants/api";

// Define a service using a base URL and expected endpoints
export const statsApi = createApi({
  reducerPath: "stats",
  baseQuery: fetchBaseQuery({ baseUrl: API_URL }),
  endpoints: (builder) => ({
    getOverviewStats: builder.query<any, string>({
      query: (type) =>
        `overview/chart?chart_name=overview_statistic&time=${type}`,
    }),
    getFeeChart: builder.query<any, string>({
      query: (type) =>
        `overview/chart?chart_name=fee_txs_statistic&time=${type}`,
    }),
    getNewAccountChart: builder.query<any, string>({
      query: (type) =>
        `overview/chart?chart_name=new_account_statistic&time=${type}`,
    }),
    getTxsChart: builder.query<any, string>({
      query: (type) => `overview/chart?chart_name=txs_statistic&time=${type}`,
    }),
  }),
});
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetOverviewStatsQuery,
  useGetFeeChartQuery,
  useGetNewAccountChartQuery,
  useGetTxsChartQuery,
} = statsApi;
